import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let selected_patient_id = useDataValue({
    context: 'patient',
    path: '_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { selected_patient_id },
    requestPolicy: 'cache-and-network',
  }
}
